import { Card } from '@mui/material';
import { Box, styled } from '@mui/system';
import { useThemeContext } from 'app/ThemeProvider';

const CardRoot = styled(Card)(() => ({
  height: '100%',
  padding: '20px 24px',
}));

const CardTitle = styled('div')(({ subtitle }) => ({
  fontSize: '1rem',
  fontWeight: '500',
  textTransform: 'capitalize',
  marginBottom: !subtitle && '16px',
}));

const SimpleCard = ({ children, title, subtitle, icon }) => {
  const { darkTheme } = useThemeContext();
  return (
    <CardRoot style={{ backgroundColor: darkTheme ? '#333333' : '#fff', color: darkTheme ? '#F2E34C' : '#000' }} elevation={6}>
      <CardTitle subtitle={subtitle}>{title}</CardTitle>
      {subtitle && <Box sx={{ mb: 2 }}>{subtitle}</Box>}
      {children}
    </CardRoot>
  );
};

export default SimpleCard;
